<template>
  <span>
    <template v-if="loading">
      <v-progress-circular
        indeterminate
        color="primary"
        :width="3"
        :size="20"
      ></v-progress-circular>
    </template>
    <template v-else>
      <v-btn :disabled="disabled" icon style="margin: 0" @click="onClickUploadButton">
        <v-icon class="outlined">photo_size_select_actual</v-icon>
      </v-btn>
    </template>

    <input
      :disabled="disabled"
      multiple
      type="file"
      class="form-control-file pt-2"
      name="photoUpload"
      :id="'photoUploadInput' + objId"
      data-vv-as="File"
      v-validate="'image|size:10240|mimes:image/jpeg,image/png,image/jpg,image/gif'"
      accept=".jpg, .png, .jpeg, .gif"
      @change="onFileChange($event)"
      style="overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;"
    />
  </span>
</template>
<script>
import UploadSingleFile from './UploadSingleFile.js'
export default {
  mixins: [UploadSingleFile]
}
</script>



// WEBPACK FOOTER //
// src/components/elements/UploadFileIcon.vue